<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" :query-api="queryApi"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolProblematicPrResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" withCustomRowActions editDisable
                                      :query-api="queryApi"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="search"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   showName
                                                   customLabel="查看PR"
                                                   @click="getPrPage(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template #left-header>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolProblematicPr'].checkedItems.length !== 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogFeedbackVisible = true"
                                    >填写反馈意见
                                    </b-button>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="反馈意见" :visible.sync="dialogFeedbackVisible">
            <el-form>
                <el-form-item label="反馈意见">
                    <el-input type="textarea" v-model="feedbackDescription" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="附件">
                    <multi-attachment class="w-100"
                                      @idsChanged="changeAttachmentIds"
                                      :attachment-ids="attachmentIds">
                    </multi-attachment>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFeedbackVisible = false">取 消</el-button>
                <el-button type="primary" @click="filledFeedback">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-07-31 09:21:14

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import MultiAttachment from "../../../components/echarts-part/stuff/MultiAttachment.vue";

export default {
    name: "sithMesStoolProblematicPrListView",
    components: {MultiAttachment, MiniButton},
    mixins: [emCommonListMixin, emCommonApiMixin, PageMaterialDownloadBomDrawingMixin],
    data() {
        return {
            feedbackDescription: '',
            dialogFeedbackVisible: false,
            queryApi: 'findAllByHandler',
            attachmentIds: '',
        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    methods: {
        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
        getPrPage(row) {
            this.$router.push({name: 'sithMesStoolOpenPrList', params: {prId: row.prId}});
        },
        filledFeedback() {
            this.dialogFeedbackVisible = false;
            let row = this.$store.state[this.modelName].entity;
            row.problemReport = this.attachmentIds;
            row.problemDescription = this.feedbackDescription;
            let url = this.$store.state.sithMesStoolPr.baseModuleUrl + "/sithMesStoolProblematicPr/feedback";
            this.$_emApiMixin_post(url, row)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "通知完成！");
                    this.$refs["emListFilter"].doQuery();
                })
        }
    },
    computed: {
        modelName() {
            return 'sithMesStoolProblematicPr';
        },
        $_rowMaterialKey() {
            return 'matCode';
        }
    },
    mounted() {
        let prId = this.$route.query.prId;
        if (prId) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('prIdFilter', prId);
        }
        this.$refs["emListFilter"].doQuery();
    }
};
</script>
